import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container mx-auto px-0 lg:px-3 mt-10" }
const _hoisted_2 = { class: "grid grid-cols-12 items-start gap-3" }
const _hoisted_3 = { class: "col-span-12 sm:col-span-12 lg:col-span-3 flex flex-col gap-5 mt-6" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "rounded-lg border border-gray-200 overflow-hidden mt-[8px]" }
const _hoisted_7 = { class: "flex flex-col w-100" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "flex justify-between items-center w-full" }
const _hoisted_10 = { class: "hover:scale-95 transition-all" }
const _hoisted_11 = {
  key: 0,
  class: "col-span-12 sm:col-span-12 lg:col-span-9 flex flex-col gap-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Info = _resolveComponent("Info")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_SelectUsers = _resolveComponent("SelectUsers")!
  const _component_TabView = _resolveComponent("TabView")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.$route.params.id)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_4, _toDisplayString(_ctx.$t("labels.add", { pt: "Turma", en: "Class" })), 1))
          : (_openBlock(), _createElementBlock("h4", _hoisted_5, _toDisplayString(_ctx.$t("labels.edit", { pt: "Turma", en: "Class" })), 1)),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buttons, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: _normalizeClass(`p-5 ${
                i == _ctx.active
                  ? 'btn-tab-active'
                  : item.done || !item.off
                  ? 'btn-tab-done'
                  : 'btn-tab-gray'
              }`),
                disabled: item.off
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(item.title), 1),
                  (item.done)
                    ? (_openBlock(), _createBlock(_component_v_icon, {
                        key: 0,
                        name: "hi-solid-check-circle",
                        class: "text-h-success-500"
                      }))
                    : _createCommentVNode("", true)
                ])
              ], 10, _hoisted_8))
            }), 128))
          ])
        ])
      ]),
      (!_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_TabView, {
              class: "custom-tabs-objective",
              activeIndex: _ctx.active
            }, {
              default: _withCtx(() => [
                _createVNode(_component_TabPanel, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Info, {
                      onOnNext: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeTab(1))),
                      onOnAllow: _ctx.allowSteps,
                      classroom: _ctx.classroom
                    }, null, 8, ["onOnAllow", "classroom"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_TabPanel, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_SelectUsers, {
                      onOnAllow: _ctx.allowSteps,
                      onOnBack: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeTab(0))),
                      classroom: _ctx.classroom
                    }, null, 8, ["onOnAllow", "classroom"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["activeIndex"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}